<template lang="html">
    <div class="addProject"  :class="{dark:darkmode}">
      <div class="contentWrapper">
        <h2>Add Project</h2>
        <AveInput :darkmode = "darkmode" v-model="projecTitle" icon="projects" placeholder="Project Name, Topic,..." :error="errorTitle" @focussed="errorTitle=''"/>
        <h2>Add your First Todo</h2>
        <AveInput :darkmode = "darkmode" v-model="todoTitle" icon="task" placeholder="Task, To Do,..." :error="errorTodoTitle" @focussed="errorTodoTitle=''"/>
        <AveInput :darkmode = "darkmode" v-model="todoTimeTracking" icon="timetracking" placeholder="10 hours, 10:00h, 2400min" :error="errorTime" @focussed="errorTime='', todoTimeTracking= ''" @blurred="checkTimeTrack"/>
        <AveInput :darkmode = "darkmode" v-model="todoLabel" icon="label" placeholder="#Label" :error="errorLabel" @focussed="errorLabel=''"/>
        <div class="container">
          <AveButton :darkmode = "darkmode" icon="wrong" icon-type="negative" label="Close" @click="stopEdit" />
          <div class="gap"></div>
          <AveButton :darkmode = "darkmode" icon="done" icon-type="positive" label="Done" @click="addEditProject"/>
        </div>
    </div>
    </div>
</template>

<script>
import AveInput from '@/components/AveInput.vue';
import AveButton from '@/components/AveButton.vue';

export default {
  name: 'Components',
  components: {
    AveInput,
    AveButton,
  },
  data() {
    return {
      error: false,
      projecTitle: '',
      todoTitle: '',
      todoTimeTracking: '',
      todoLabel: '',
      errorTitle: '',
      errorTodoTitle: '',
      errorTime: '',
      errorLabel: '',
    };
  },
  methods: {
    addEditProject() {
      if (this.projecTitle && this.todoTitle && this.todoTimeTracking && this.todoLabel) {
        const currentDate = new Date();
        const dd = String(currentDate.getDate()).padStart(2, '0');
        const mm = String(currentDate.getMonth() + 1).padStart(2, '0');
        const yyyy = currentDate.getFullYear();
        const projectDate = `${dd}.${mm}.${yyyy}`;
        // console.log(this.todoTimeTracking);
        const data = {
          title: this.projecTitle,
          createdAt: projectDate,
          time: this.todoTimeTracking,
          todoTitle: this.todoTitle,
          todoLabel: `#${this.todoLabel}`,
        };
        // console.log(data.time);
        this.$emit('emitInputs', data);
        this.projecTitle = '';
        this.todoTitle = '';
        this.todoTimeTracking = '';
        this.todoLabel = '';
      } else {
        if (!this.projecTitle) {
          this.errorTitle = 'Add a project title first!';
        }
        if (!this.todoTitle) {
          this.errorTodoTitle = 'You have to add a title for your to do!';
        }
        if (!this.todoTimeTracking) {
          this.errorTime = 'You need to estimate how long this task will take you to complete!';
        }
        if (!this.todoLabel) {
          this.errorLabel = 'You need to add a specific label that defines your task!';
        }
      }
    },

    checkTimeTrack() {
      if (Number.isNaN(Number.parseInt(this.todoTimeTracking, 10))) {
        this.errorTime = 'Value needs to be a Number';
      }
    },

    stopEdit() {
      this.$emit('close');
      this.projecTitle = '';
      this.todoTitle = '';
      this.todoTimeTracking = '';
      this.todoLabel = '';
      this.errorTitle = '';
      this.errorTodoTitle = '';
      this.errorTime = '';
      this.errorLabel = '';
    },
  },
  props: {
    darkmode: Boolean,
  },
};
</script>

<style lang="stylus" scoped>
@require '../assets/styles/colors.styl'
@require '../assets/styles/styles.styl'

.addProject
  border-color $normal
  border $borderBoxes
  box-shadow $shadow
  border-radius $radiusBoxes
  background-color: $darkmodeWhite

  &.dark
    border-color: $darkmodeWhite

    h2
      color: $darkmodeWhite

.container
  display flex
  flex-direction row

  .gap
    width: 25px

.contentWrapper
  width: $contentWrapperWidth
  margin: auto
</style>
